import { Injector } from '@angular/core';
import { ActionButtonOutcomesType, BaseWidgetProperties } from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { first } from 'rxjs';
import { ResetFormDataAction } from '../../../actions/form-submission.action';
import { handleRedirection } from '../cta-redirection.utils';

export function clearFormStateAndRedirect(injector: Injector, widgetProperties: BaseWidgetProperties) {
  const store = injector.get(Store);
  //close the subscription after first emit
  store
    .dispatch(new ResetFormDataAction())
    .pipe(first())
    .subscribe(() => {
      handleRedirection(widgetProperties, injector, ActionButtonOutcomesType.SUCCESS);
    });
}
